import { useState } from 'react'

import { joinWaitlist } from '../../../../utilities/api'

import './joinWaitlist.scss'

function waitlistErrorMessage(error) {
  return (
    error?.response?.data?.error?.message ||
    error?.response?.data?.message ||
    'Could not join the waitlist. Try again.'
  )
}

export default function JoinWaitlist({
  eventUuid,
  offerId,
  offerUuid,
  offerName,
  defaultQuantity = 1,
}) {
  const [email, setEmail] = useState('')
  const [quantity, setQuantity] = useState(defaultQuantity)
  const [status, setStatus] = useState('idle')
  const [message, setMessage] = useState('')

  const submit = async (event) => {
    event.preventDefault()
    event.stopPropagation()
    if (!eventUuid) {
      setStatus('error')
      setMessage('This event is not ready for a waitlist yet.')
      return
    }

    setStatus('loading')
    setMessage('')
    try {
      const response = await joinWaitlist({
        email,
        quantity,
        eventUuid,
        offerId,
        offerUuid,
        offerName,
      })
      setStatus('done')
      setMessage(
        response.data?.alreadyJoined
          ? "You're already on the waitlist. We'll email you if tickets open up."
          : "You're on the waitlist. We'll email you if tickets open up."
      )
    } catch (error) {
      setStatus('error')
      setMessage(waitlistErrorMessage(error))
    }
  }

  if (status === 'done') {
    return <p className="join-waitlist__done">{message}</p>
  }

  return (
    <form
      className="join-waitlist"
      onSubmit={submit}
      onClick={(event) => event.stopPropagation()}
    >
      <input
        type="email"
        required
        placeholder="Email address"
        value={email}
        aria-label="Email address"
        onChange={(event) => setEmail(event.target.value)}
      />
      <input
        type="number"
        min={1}
        max={10}
        value={quantity}
        aria-label="Number of tickets"
        onChange={(event) => setQuantity(Number(event.target.value))}
      />
      <button type="submit" disabled={status === 'loading' || !email}>
        {status === 'loading' ? 'Joining…' : 'Join waitlist'}
      </button>
      {message ? <p className="join-waitlist__error">{message}</p> : null}
    </form>
  )
}
